import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.text.white,
      userSelect: 'none',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      maxWidth: 'max-content',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    formContainer: {
      maxWidth: '450px',
      width: '100%'
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      textAlign: 'start'
    },
    littleText: {
      fontSize: '0.625rem'
    },
    buttons: {
      display: 'flex',
      justifyContent: 'center',
      height: '39px'
    },
    help: {
      fontSize: '0.875rem',
      display: 'flex',
      color: palette.common.red,
      flexDirection: 'column',
      gap: '20px',
      '@media (max-width: 768px)': {
        paddingLeft: '20px'
      }
    },
    title: {
      fontSize: '2.5rem',
      margin: '0',
      '@media (max-width: 768px)': {
        fontSize: '1.75rem'
      }
    },
    space: {
      marginBottom: '5px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
